








import { Component, Vue, Prop } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'

@Component({
  componentName: 'InputFormDialogBody'
})
export default class InputFormDialogBody extends Vue {
  @Prop({
    default: ''
  })
  value?: string

  @Prop()
  rules!: any

  @Prop()
  placeholder?: string

  @Prop()
  inputProps?: any

  @Prop()
  submit!: Function

  $refs!: {
    form: ElForm
  }

  form = {
    input: this.value
  }

  onOk () {
    this.$refs.form.validate().then((valid: boolean) => {
      if (valid) {
        this.submit(this.form.input)
      }
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
  }
}
